'use client'
import { useState } from 'react'
import Link from 'next/link'

const NameFilter = ({ lang, dictionary }) => {

    const [name, setName] = useState('')

    return (
        <div className='w-full flex flex-col items-start justify-center'>
            <label className='text-maincolor text-xl pb-2'>{dictionary.search}:</label>
            <div className='flex flex-row'>
                <input
                    className='w-full rounded-md border-[1px] border-forth text-secondary py-2 pl-2 text-md leading-5 focus:ring-0'
                    placeholder='Enter Listing ID'
                    type='text'
                    name='id'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />

            </div>
        </div>
    )
}

export default NameFilter